/** Nhãn tiếng Việt cho internal_status trong Transaction Logs (payment). */
export const INTERNAL_STATUS_LABELS: Record<string, string> = {
  PENDING: 'Chờ xử lý',
  PENDING_APPROVAL: 'Chờ duyệt',
  SUCCEEDED: 'Thành công',
  CAPTURED: 'Đã thu tiền',
  COMPLETED: 'Hoàn tất',
  FAILED: 'Thất bại',
  CANCELLED: 'Đã hủy',
  EXPIRED: 'Hết hạn',
};

export const REFUND_INTERNAL_STATUS_LABELS: Record<string, string> = {
  PENDING: 'Chờ hoàn tiền',
  SUCCEEDED: 'Đã hoàn tiền',
  FAILED: 'Hoàn tiền thất bại',
};

export const INTERNAL_STATUS_FILTER_OPTIONS = [
  { value: '', label: 'Tất cả' },
  { value: 'PENDING', label: INTERNAL_STATUS_LABELS.PENDING },
  { value: 'PENDING_APPROVAL', label: INTERNAL_STATUS_LABELS.PENDING_APPROVAL },
  { value: 'SUCCEEDED', label: INTERNAL_STATUS_LABELS.SUCCEEDED },
  { value: 'CAPTURED', label: INTERNAL_STATUS_LABELS.CAPTURED },
  { value: 'COMPLETED', label: INTERNAL_STATUS_LABELS.COMPLETED },
  { value: 'FAILED', label: INTERNAL_STATUS_LABELS.FAILED },
  { value: 'CANCELLED', label: INTERNAL_STATUS_LABELS.CANCELLED },
  { value: 'EXPIRED', label: INTERNAL_STATUS_LABELS.EXPIRED },
];

export function formatInternalStatusLabel(
  status: string | null | undefined,
  transactionType?: string | null
): string {
  if (!status) return '–';
  if (transactionType === 'refund') {
    return (
      REFUND_INTERNAL_STATUS_LABELS[status] ||
      INTERNAL_STATUS_LABELS[status] ||
      status
    );
  }
  return INTERNAL_STATUS_LABELS[status] || status;
}
